import { memo, ReactNode } from 'react'
import tw from 'twin.macro'
import { TableTab } from './TableTab'

export interface TableTab<V> {
  title: string
  value: V
  subtitle?: string
  renderIcon: (selected: boolean) => ReactNode
}

interface Props<V> {
  tabs: TableTab<V>[]
  selectedValue: V
  onClick(value: V): void
}

const TableTabsComponent = <V extends any>({ tabs, selectedValue, onClick }: Props<V>) => (
  <div css={tw`bg-white rounded-t-lg flex w-full overflow-hidden`}>
    {tabs.map((item) => (
      <TableTab
        title={item.title}
        key={item.title}
        value={item.value}
        icon={item.renderIcon(item.value === selectedValue)}
        subtitle={item.subtitle}
        selected={item.value === selectedValue}
        onClick={onClick}
      />
    ))}
  </div>
)

export const TableTabs = memo(TableTabsComponent) as typeof TableTabsComponent
